export const recruitNowWebhookQueryKeys = {
  all: ["recruitNowWebhooks"] as const,
  overview: () => [...recruitNowWebhookQueryKeys.all, "overview"] as const,
  overviewList: (params: unknown) =>
    [...recruitNowWebhookQueryKeys.overview(), params] as const,
  clientRegistrations: (clientId?: string | null, page?: number, pageSize?: number) =>
    [...recruitNowWebhookQueryKeys.all, "clientRegistrations", clientId, page, pageSize] as const,
  clientRegistrationsInfinite: (clientId?: string | null, excludeId?: string | null) =>
    [...recruitNowWebhookQueryKeys.all, "clientRegistrationsInfinite", clientId, excludeId] as const,
  registrationById: (clientId?: string | null, registrationId?: string | null) =>
    [...recruitNowWebhookQueryKeys.all, "registrationById", clientId, registrationId] as const,
  configuration: (clientId?: string | null) =>
    [...recruitNowWebhookQueryKeys.all, "configuration", clientId] as const,
};
